import config from './../config'

const CLOUD_ASSETS_URL = `${config.firebase.assetsUrl}/assets/communities`
export const APP_LAUNCHER_ICON = `${CLOUD_ASSETS_URL}/app-launcher.svg`
export const SETTINGS_ICON = `${CLOUD_ASSETS_URL}/settings.svg`
export const NOTIFICATION_ICON = `${CLOUD_ASSETS_URL}/notification-icon.svg`
export const GROUP_AVATAR_ICON = `${CLOUD_ASSETS_URL}/group-avatar.svg`
export const PUBLIC_GROUP_ICON = `${CLOUD_ASSETS_URL}/public-group-icon.svg`
//export const Private_GROUP_ICON = `${CLOUD_ASSETS_URL}/private-group-icon.svg`
export const PRIVATE_GROUP_ICON = `https://storage.googleapis.com/staging-client-app-revex-communities/communities/Private_Group_Icon.svg`
export const FEATURED_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/featured_icon.svg'
export const LINK_ICON = `${CLOUD_ASSETS_URL}/link-icon.svg`
export const LIKE_ICON = `${CLOUD_ASSETS_URL}/like-icon.svg`
export const COMMENTS_ICON = `${CLOUD_ASSETS_URL}/comments-icon.svg`
export const ADD_CHANNEL_ICON = `https://storage.googleapis.com/staging-client-app-revex-communities/communities/add-channel-icon.svg`
export const PERSON_ICON = `https://storage.googleapis.com/staging-client-app-revex-communities/communities/person_icon.svg`
export const SMILE_ICON = `https://storage.googleapis.com/staging-client-app-revex-communities/communities/smile_icon.svg`
export const HASH_ICON = `https://storage.googleapis.com/staging-client-app-revex-communities/communities/hash_icon.svg`
export const LEARNING_COMING_SOON = `https://storage.googleapis.com/revex-communities-staging/assets/learning_coming_soon.png`
export const OWNER_AVATAR_BADGE = `https://storage.googleapis.com/revex-communities-staging/assets/owner_avatar_badge.svg`
export const ADMIN_AVATAR_BADGE = `https://storage.googleapis.com/revex-communities-staging/assets/admin_avatar_badge.svg`
export const UNPIN_POST_ICON = `https://storage.googleapis.com/revex-communities-staging/assets/unpin_icon.svg`
export const NO_COURSES_FOUND_ICON = `https://storage.googleapis.com/revex-communities-staging/assets/no-courses-found.svg`
export const LEADERBOARD_1ST_POSITION_ICON = `https://storage.googleapis.com/revex-communities-staging/assets/coin_1.svg`
export const LEADERBOARD_2ND_POSITION_ICON = `https://storage.googleapis.com/revex-communities-staging/assets/coin_2.svg`
export const LEADERBOARD_3RD_POSITION_ICON = `https://storage.googleapis.com/revex-communities-staging/assets/coin_3.svg`
export const GOKOLLAB_K_LOGO_ONLY = `https://storage.googleapis.com/revex-gokollab-production/assets/gokollab-without-border-v4.png`
export const GOKOLLAB_DEFAULT_LOGO = `https://storage.googleapis.com/revex-gokollab-production/assets/gokollab-logo-light-theme-v4.webp`

export const MEMBERSHIP_ASSETS_BUCKET =
  'https://storage.googleapis.com/revex-membership-staging'
export const FACEBOOK_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/facebook.svg'
export const INSTAGRAM_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/instagram-icon.svg'
export const TWITTER_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/twitter.svg'
export const YOUTUBE_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/youtube.svg'
export const LINKEDIN_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/linkedin.svg'
export const INVITATION_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/invitation_modal_icon.svg'
export const COURSES_DEFAULT_IMAGE =
  'https://storage.googleapis.com/revex-communities-staging/assets/courses_default_placeholder.svg'
export const LIKE_ICON_INACTIVE =
  'https://storage.googleapis.com/revex-communities-staging/assets/custom-like-inactive.svg'
export const LIKE_ICON_ACTIVE =
  'https://storage.googleapis.com/revex-communities-staging/assets/custom-like-active.svg'
export const COMMENT_ICON_INACTIVE =
  'https://storage.googleapis.com/revex-communities-staging/assets/custom-comment-inactive.svg'
export const COMMENT_ICON_ACTIVE =
  'https://storage.googleapis.com/revex-communities-staging/assets/custom-comment-active.svg'
export const ALLOWED_FILE_TYPES = [
  'image/svg+xml',
  'image/png',
  'image/webp',
  'image/jpg',
  'image/jpeg',
]

export const supportedVideoTypes = [
  {
    extension: '.mp4',
    type: 'video/mp4',
  },
  {
    extension: '.webm',
    type: 'video/webm',
  },
  {
    extension: '.mov',
    type: 'video/quicktime',
  },
]

export const supportedMediaTypes = [
  // Images
  'image/png',
  'image/svg+xml',
  'image/jpeg',
  'image/jpg',
  'image/heic',
  'image/heif',
  'image/gif',
  // Videos
  'video/mp4',
  'video/quicktime', // MOV format
  'video/webm',
]

export const supportedFiles = [
  'application/pdf',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/xml',
  'application/msword',
]

export const GAMIFICATION_LEVELS = {
  '1': { minPoints: 0, maxPoints: 4 },
  '2': { minPoints: 5, maxPoints: 19 },
  '3': { minPoints: 20, maxPoints: 64 },
  '4': { minPoints: 65, maxPoints: 154 },
  '5': { minPoints: 155, maxPoints: 514 },
  '6': { minPoints: 515, maxPoints: 2014 },
  '7': { minPoints: 2015, maxPoints: 8014 },
  '8': { minPoints: 8015, maxPoints: 33014 },
  '9': { minPoints: 33015, maxPoints: 1000000 },
}

export const MAX_POST_ATTACHMENTS_LIMIT = 4

export const GAMIFICATION_LEVELS_OPTIONS = Object.keys(GAMIFICATION_LEVELS).map(
  level => ({
    label: `0${level}`,
    value: parseInt(level, 10),
  })
)
